module.exports = __webpack_public_path__ + "img/graph_8.73f1fe07.png";